import React, { FunctionComponent } from "react";
import className from "classnames";
import { Button } from "@cmsgov/ds-medicare-gov";

interface PageNumberProps {
  isActive: boolean;
  isDisabled: boolean;
  pageNum: number;
  onClick: (pageNum: number, scrollToTop: boolean) => void;
}

const PageNumber: FunctionComponent<PageNumberProps> = ({
  pageNum,
  isActive,
  isDisabled,
  onClick,
}) => {
  const handleOnClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void => {
    event.preventDefault();
    onClick(pageNum, true);
  };

  return (
    <Button
      className={className(
        "pagination__numberButton",
        isActive && "pagination__numberButton--active"
      )}
      disabled={isDisabled}
      onClick={handleOnClick}
    >
      {`${pageNum + 1} `}
    </Button>
  );
};

export default PageNumber;
